import React from 'react'
import { Button, Col, Modal, Popconfirm, Row } from 'antd'
import PayrollClaimLineForm
  from '../../../../../components/People/PayrollClaim/AddPayrollClaim/Lines/PayrollClaimLineForm'

function PayrollClaimLineModal (props) {
  const {
    remove,
    submit,
    update,
    visible,
    modalType,
    formRef,
    onCancel,
    removingLine,
    isUpdatable,
    submitting,
    onPullData,
    pulling,
  } = props
  const isNew = modalType === 'new'
  return (
    <Modal
      visible={visible}
      title={'Salaries Lines'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <Row>
          <Col span={24} style={{ textAlign: 'right' }}>
            <Popconfirm
              title={'Payroll Claim Line'}
              onConfirm={remove}
              okText="Yes"
              cancelText="No">
              <Button
                type="danger"
                loading={removingLine}
                style={{ marginLeft: 8, marginRight: 8 }}>
                Remove
              </Button>
            </Popconfirm>
            <Button loading={pulling} type="dashed" onClick={onPullData}>
              {'Re-Pull Data'}
            </Button>
          </Col>
        </Row>
      }
      width={'75%'}>
      <PayrollClaimLineForm ref={formRef} {...props} />
    </Modal>
  )
}

PayrollClaimLineModal.propTypes = {}
PayrollClaimLineModal.defaultProps = {}

export default PayrollClaimLineModal
